import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectCutReturnlist } from '../../Selectors/Master/ItemSelectors';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchCuttingReturnlist } from '../../../Store/PHPSlice/Cutting/cuttingApi';

const ContReturnInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        empNm: '',
        empType: '',
        cutId: '',
        cutMemo: '',
        reMemo: '',
        itemId: '',
        itemNm: '',
        reQty: '',
        totQty: '',
        gMtr: '',
        actAvg: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        soId: '',
        sono: '',
        partyId: '',
        partyNm: '',
        schlNm: '',
        schlId: '',
        mavg: '0',
        m1avg: '0',
        m2avg: '0',
        m3avg: '0',
        mgmtr: '',
        m1gmtr: '',
        m2gmtr: '',
        m3gmtr: '',
        mused: '0',
        m1used: '0',
        m2used: '0',
        m3used: '0',
        instruction: '',
        userId: '1'
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const returnInfolist = useSelector(selectCutReturnlist);
    var itemData = returnInfolist.returnInfo.length > 0 ? {
        size: returnInfolist.returnInfo.map(val => val.size),
        issqty: returnInfolist.returnInfo.map(val => parseFloat(val.issqty)),
        dqty: returnInfolist.returnInfo.map(val => parseFloat(val.dqty)),
        eqty: returnInfolist.returnInfo.map(val => parseFloat(val.eqty)),
        rbqty: returnInfolist.returnInfo.map(val => parseFloat(val.rbqty)),
        rqty: returnInfolist.returnInfo.map(val => parseFloat(val.rqty)),
        sts: returnInfolist.returnInfo.map(val => parseFloat(val.sts))
    } : null;

    // var cuttingInfolist = returnInfolist.cuttingInfo.length > 0 ? {
    //     size: returnInfolist.cuttingInfo.map(val => val.size),
    //     mavg: returnInfolist.cuttingInfo.map(val => parseFloat(val.mavg)),
    //     m1avg: returnInfolist.cuttingInfo.map(val => parseFloat(val.m1avg)),
    //     m2avg: returnInfolist.cuttingInfo.map(val => parseFloat(val.m2avg)),
    //     m3avg: returnInfolist.cuttingInfo.map(val => parseFloat(val.m3avg)),
    // } : null;

    console.log(returnInfolist)

    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchCuttingReturnlist(Id));
    }, [Id]);

    useEffect(() => {
        if (returnInfolist.data && returnInfolist.data.length > 0 && returnInfolist.returnInfo.length > 0) {
            const item = returnInfolist.data[0];
            const reqty = returnInfolist.returnInfo.map(item => item.rqty);
            const totReturnqty = reqty.reduce((sum, qty) => sum + parseFloat(qty), 0);
            let calActavg = 0;
            calActavg = parseFloat(item.mgmtr) / totReturnqty;
            setFormData(prev => ({
                ...prev,
                dt: item.dt || '',
                empId: item.empId || '',
                empNm: item.empNm || '',
                empType: item.empType || '',
                itemId: item.itemId || '',
                itemNm: item.itemNm || '',
                reQty: item.totReturnqty || '',
                totQty: item.totIssqty || '',
                gMtr: item.mgmtr || '',
                soId: item.soId || '',
                sono: item.sono || '',
                // partyId: item.partyId || '',
                // partyNm: item.partyNm || '',
                mcloth: item.mcloth || '',
                mclothNm: item.mclothNm || '',
                m1cloth: item.m1cloth || '',
                m1clothNm: item.m1clothNm || '',
                m2cloth: item.m2cloth || '',
                m2clothNm: item.m2clothNm || '',
                m3cloth: item.m3cloth || '',
                m3clothNm: item.m3clothNm || '',
                // schlId: item.schoolId,
                // schlNm: item.schoolNm,
                cutId: item.ctId,
                cutMemo: item.ctMemo,
                reMemo: Id,
                mgmtr: item.mgmtr,
                m1gmtr: item.m1gmtr,
                m2gmtr: item.m2gmtr,
                m3gmtr: item.m3gmtr,
                actAvg: calActavg.toFixed(2) || 0,
                mused: item.mused,
                m1used: item.m1used,
                m2used: item.m2used,
                m3used: item.m3used,
                instruction: item.instruction
            }));
        }

    }, [returnInfolist]);

    // useEffect(() => {
    //     if (itemData && cuttingInfolist) {
    //         // Calculate new average values
    //         const newMavg = itemData.rqty.reduce((sum, rqtyValue, index) => sum + rqtyValue * cuttingInfolist.mavg[index], 0);
    //         const newM1avg = itemData.rqty.reduce((sum, rqtyValue, index) => sum + rqtyValue * cuttingInfolist.m1avg[index], 0);
    //         const newM2avg = itemData.rqty.reduce((sum, rqtyValue, index) => sum + rqtyValue * cuttingInfolist.m2avg[index], 0);
    //         const newM3avg = itemData.rqty.reduce((sum, rqtyValue, index) => sum + rqtyValue * cuttingInfolist.m3avg[index], 0);

    //         // Only update if values have changed
    //         setFormData(prev => {
    //             const newFormData = {
    //                 ...prev,
    //                 mavg: newMavg,
    //                 m1avg: newM1avg,
    //                 m2avg: newM2avg,
    //                 m3avg: newM3avg,
    //             };

    //             // Check if the new values are different from the old ones
    //             if (
    //                 prev.mavg !== newMavg ||
    //                 prev.m1avg !== newM1avg ||
    //                 prev.m2avg !== newM2avg ||
    //                 prev.m3avg !== newM3avg
    //             ) {
    //                 return newFormData;
    //             }

    //             // Return the previous state if nothing has changed
    //             return prev;
    //         });
    //     }
    // }, [itemData, cuttingInfolist]); // Dependencies

    const pannaAvg_maincloth = parseFloat(formData.mused) / parseFloat(formData.reQty);
    const pannaAvg_m1cloth = parseFloat(formData.m1used) / parseFloat(formData.reQty);
    const pannaAvg_m2cloth = parseFloat(formData.m2used) / parseFloat(formData.reQty);
    const pannaAvg_m3cloth = parseFloat(formData.m3used) / parseFloat(formData.reQty);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Return Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                    {/* <td style={{ width: '200px' }}>Memo No.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.memoNo}</td> */}

                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Return Memo No.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.reMemo}</td>
                                    <td style={{ width: '200px' }}>Cutting Memo No.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.cutMemo}</td>
                                </tr>


                                {formData.soId !== '0' &&
                                    <>
                                        <tr>
                                            <td style={{ width: '200px' }}>Sale Order No.</td>
                                            <td>:</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>
                                            <td style={{ width: '200px' }}>Party</td>
                                            <td>:</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.partyNm}</td>
                                        </tr>

                                        <tr>
                                            <td style={{ width: '200px' }}>School Name</td>
                                            <td>:</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.schlNm}</td>

                                        </tr>
                                    </>

                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Item</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>


                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Issue Qty.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totQty}</td>

                                    <td style={{ width: '200px' }}>Return Qty.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.reQty}</td>

                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Cutting Instruction</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>


                                </tr>
                            </tbody>
                        </table>


                        <div style={{ marginBottom: '3vh' }}>
                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>

                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Main Cloth</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.mclothNm}</TableCell>
                                        {formData.m1cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-1 Cloth</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m1clothNm}</TableCell>
                                            </>
                                        }
                                        {formData.m2cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-2 Cloth</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m2clothNm}</TableCell>
                                            </>
                                        }
                                        {formData.m3cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-3 Cloth</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m3clothNm}</TableCell>
                                            </>
                                        }
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Main Given Mtr.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.mgmtr}</TableCell>
                                        {formData.m1cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-1 Given Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m1gmtr}</TableCell>
                                            </>
                                        }
                                        {formData.m2cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-2 Given Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m2gmtr}</TableCell>
                                            </>
                                        }
                                        {formData.m3cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-3 Given Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m3gmtr}</TableCell>
                                            </>
                                        }
                                    </TableRow>
                                    <TableRow>

                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Main Used Mtr.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.mused}</TableCell>
                                        {formData.m1cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-1 Used Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m1used}</TableCell>
                                            </>
                                        }
                                        {formData.m2cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-2 Used Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m2used}</TableCell>
                                            </>
                                        }
                                        {formData.m3cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-3 Used Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m3used}</TableCell>
                                            </>
                                        }
                                    </TableRow>
                                    <TableRow>

                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Main Remain Mtr.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{parseFloat(formData.mgmtr) - parseFloat(formData.mused)}</TableCell>
                                        {formData.m1cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-1 Remain Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{parseFloat(formData.m1gmtr) - parseFloat(formData.m1used)}</TableCell>
                                            </>
                                        }
                                        {formData.m2cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-2 Remain Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{parseFloat(formData.m2gmtr) - parseFloat(formData.m2used)}</TableCell>
                                            </>
                                        }
                                        {formData.m3cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-3 Remain Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{parseFloat(formData.m3gmtr) - parseFloat(formData.m3used)}</TableCell>
                                            </>
                                        }
                                    </TableRow>
                                    <TableRow>

                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Main Panna Avg.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{pannaAvg_maincloth.toFixed(2)}</TableCell>
                                        {formData.m1cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-1 Panna Avg.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{pannaAvg_m1cloth.toFixed(2)}</TableCell>
                                            </>
                                        }
                                        {formData.m2cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-2 Panna Avg.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{pannaAvg_m2cloth.toFixed(2)}</TableCell>
                                            </>
                                        }
                                        {formData.m3cloth !== '0' &&
                                            <>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Match-3 Panna Avg.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{pannaAvg_m3cloth.toFixed(2)}</TableCell>
                                            </>
                                        }
                                    </TableRow>
                                </Table>
                            </TableContainer>
                        </div>

                        {itemData !== null &&
                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                            {itemData?.size ? itemData?.size?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>


                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                            {itemData?.issqty ? itemData?.issqty?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>



                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Extra Qty.</TableCell>
                                            {itemData?.eqty ? itemData?.eqty?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>


                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Return Qty.</TableCell>
                                            {itemData?.rqty ? itemData?.rqty?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>



                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Damage Qty.</TableCell>
                                            {itemData?.dqty ? itemData?.dqty?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        }
                    </div>
                    {/* <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div> */}
                </Paper>
            </Grid>
        </>
    );
};

export default ContReturnInfo;
